export enum AffiliationType {
  accountToAccount = 'a-t-a',
  accountFromAccount = 'a-f-a',
  accountToContact = 'a-t-c',
  contactToContact = 'c-t-c',
  contactFromContact = 'c-f-c',
  contactToAccount = 'c-a',
}
